module.exports = require('./helpers/bundle-url').getBundleURL('8yBhy') + "logo.c51670a8.svg";